import { z } from 'zod';
export const HttpsUrlSchema = z.url().startsWith('https://');
